import { createApi } from "@reduxjs/toolkit/query/react";
import { chargerActionType } from "redux/utils/types";
import { baseQueryWithReauth } from "./utils/constants";
import {
	FleetParams,
	FleetResponse,
} from "./utils/interfaces";
import moment from "moment";

interface specifyVehicle {
  vehicleId: string
  userName: string
}
 
const callMap:{
	[key:string]:string
} = {
	'status_is_Plugged In':'pluggedIn_is_plugged_in',
	'status_is_Not Plugged In':'pluggedIn_is_not_plugged_in'
}

const getUrlParams = (args) => {
	let filterBy = ''
	if(args.filterBy) {
		filterBy = callMap[args.filterBy]
	}
	if (!args.sortBy && !args.filterBy) {
		return `userName=${args.userName}&limit=${args.limit}&offset=${args.offset}`;
	} else if (args.sortBy && !args.filterBy) {
		return `userName=${args.userName}&limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}`;
	} else if (!args.sortBy && args.filterBy) {
		return `userName=${args.userName}&limit=${args.limit}&offset=${args.offset}&filterBy=${filterBy}`;
	} else if (args.sortBy && args.filterBy) {
		return `userName=${args.userName}&limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}&filterBy=${filterBy}`;
	}
	return `userName=${args.userName}&limit=${args.limit}&offset=${args.offset}`;
};

const getUrlParamsForTransactions = (args) => {
	if (!args.sortBy) {
		return `userName=${args.userName}&vehicleId=${args.vehicleId}&limit=${args.limit}&offset=${args.offset}`;
	}
	return `userName=${args.userName}&vehicleId=${args.vehicleId}&limit=${args.limit}&sortBy=${args.sortBy}&offset=${args.offset}`;
};

export const fleetApi = createApi({
	reducerPath: "fleet",
	baseQuery: baseQueryWithReauth,
	endpoints: (builder) => ({
		getFleets: builder.query<FleetResponse, FleetParams>({
			query: (args) => ({
				url: `get-fleet-vehicles?${getUrlParams(args)}`,
				keepUnusedDataFor: 0
			}),
		}),
    getVehicleInfo: builder.query<FleetResponse, {userName:string,vehicleId:string}>({
			query: (args) => ({
				url: `get-vehicle-info?userName=${args.userName}&vehicleId=${args.vehicleId}`,
				keepUnusedDataFor: 0
			}),
		}),
    getVehicleTransactions: builder.query<FleetResponse, FleetParams & {vehicleId:string}>({
			query: (args) => ({
				url: `get-vehicle-transactions?${getUrlParamsForTransactions(args)}&currentTime=${moment(new Date()).format().replace('+','%2B')}`,
				keepUnusedDataFor: 0
			}),
		}),
    startVehicleTransaction:builder.mutation<chargerActionType, specifyVehicle>({
			query: (data) => {
				const {userName, vehicleId} = data;
				return {
					url: "start-vehicle-transaction",
					method: "PUT",
					body: {"userName": userName, "vehicleId": vehicleId }
				};
			}
		}),
    stopVehicleTransaction:builder.mutation<chargerActionType, specifyVehicle>({
			query: (data) => {
				const {userName, vehicleId} = data;
				return {
					url: "stop-vehicle-transaction",
					method: "PUT",
					body: {"userName": userName, "vehicleId": vehicleId }
				};
			}
		})
	}),
});

export const {
	useGetFleetsQuery,
  useGetVehicleInfoQuery,
  useGetVehicleTransactionsQuery,
  useStartVehicleTransactionMutation,
  useStopVehicleTransactionMutation
} = fleetApi;
